"use client";

import React from "react";
import { styled } from "styled-components";
import { Car } from "@/data/bruktbilsalgBackend/types/car.types";
import { HighlightsSection } from "./highlightsSection";
import {
  breakpointTablet,
  Heading1Text,
  Heading2Text,
} from "@gnist/design-system";
import { Description } from "./carDescription";
import { PricingSection } from "./pricingSection";
import { Equipment } from "./equipment";
import { SpecificationsSection } from "@/app/bil/[carId]/components/specificationsSection";
import { tokens } from "@gnist/themes/tokens.css.js";

const CarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.xl};
  margin-top: ${tokens.spacing.xl};

  @media screen and (min-width: ${breakpointTablet}) {
    margin-top: ${tokens.spacing["3xl"]};
  }
`;

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.base};
`;

const StyledSubtitle = styled(Heading2Text)`
  font-size: ${tokens.typeface.size.l};
`;

interface Props {
  car: Car;
  departmentSlug?: string;
}

export const CarInformation = ({ car, departmentSlug }: Props) => {
  return (
    <CarWrapper>
      <HeadingWrapper>
        <Heading1Text $as="h1">
          {car.brand} {car.model}
        </Heading1Text>
        <StyledSubtitle>{car.variant}</StyledSubtitle>
      </HeadingWrapper>
      <HighlightsSection
        modelYear={car.modelYear}
        fuel={car.fuel}
        mileage={car.mileage}
        transmission={car.transmission}
      />
      <PricingSection car={car} departmentSlug={departmentSlug} />
      <Description description={car.description} />
      <SpecificationsSection car={car} />
      {car.equipment.length > 0 && <Equipment equipment={car.equipment} />}
    </CarWrapper>
  );
};
